export default __webpack_public_path__ + "static/media/1.b652bbd3.jpg";